jQuery( document ).ready( function( $ ) {


	$('.gallery-category-triggers button').on("click", function(e) {
		e.preventDefault();
		console.log('click');
		
		if (!$(this).hasClass('active')) {
			var target = $(this).data('trigger');
			$('.gallery-category-triggers button').removeClass('active');
			$(this).addClass('active');
			$('.gallery-item').removeClass('active');
			$('.gallery-item[data-category="'+target+'"]').addClass('active');
		}

	});

	Fancybox.bind("[data-fancybox]", {
	  zoom: false,
	  groupAttr: 'data-group'
	});


} );
